import React from 'react'
import FormControl from "@mui/material/FormControl"
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import {Context as AppContext} from "../contexts/App"

const VendorPicker = () => {
  const { vendors, vendor, vendorChange } = React.useContext(AppContext)
  return (
    <React.Fragment>
      {!vendor && "Selecciona el canal de venta"}
      {vendors && 
        <FormControl sx={{ m: 1, width: '25ch' }} >
            <InputLabel id={"label-vendor"}>Canal de Venta</InputLabel>
            <Select
              labelId="label-vendor"
              name="vendor"
              label="Canal"
              value={vendor}
              onChange={vendorChange}
            >
              {vendors.map(v => (
                <MenuItem value={v.alias}>{v.name}</MenuItem>
              ))}
            </Select>
        </FormControl>
      }
    </React.Fragment>

  )
}

export default VendorPicker